<template>
  <!-- Footer -->
  <footer id="page-footer">
    <slot>
      <div class="content py-3">
        <b-row class="font-size-sm">
          <b-col class="py-1 text-center text-sm-right">
        <!--    
           <img alt="Ennoble" data-src="https://dashboard-salvavidas.com/icons/Ennoble2.png" class="logofooter" src="https://dashboard-salvavidas.com/icons/Ennoble2.png"> Developed by <a class="font-w600" style="color:black;" href="https://ennobledesign.mx/" target="_blank">Ennoble Design</a> 
         -->
          </b-col>
        
        </b-row>
      </div>
    </slot>
  </footer>
  <!-- END Footer -->
</template>

<script>
export default {
  name: 'BaseFooter',
  props: {
    classes: String
  }
}
</script>
<style>
.logofooter{
    max-height: 40px;
    padding-bottom: 4px;
}
</style>